import { SET_THEME, SET_CONNECTION_REFERENCE, SET_MAIN_MENU_VISIBILITY, SET_HEADER_VISIBILITY, SET_FOOTER_VISIBILITY, REFRESH_STATUS_BAR } from "./Constants";

export type UiState =
{
    theme: string;
    connectionReference: unknown;
    headerVisible: boolean;
    mainMenuVisible: boolean;
    footerVisible: boolean;
    // Versión de la barra de estado: cada incremento hace que Header vuelva a pedir los avisos al servidor.
    statusBarVersion: number;
};

export const INITIAL_STATE: UiState =
{
    theme: "light",
    connectionReference: null,
    headerVisible: true,
    mainMenuVisible: true,
    footerVisible: true,
    statusBarVersion: 0,
};

type UiAction =
{
    type: string;
    payload?: any;
};

export default function uiReducer(state: UiState = INITIAL_STATE, action: UiAction): UiState
{
    switch(action.type)
    {
        case SET_THEME:
            return { ...state, theme: action.payload };
        case SET_CONNECTION_REFERENCE:
            return { ...state, connectionReference: action.payload };
        case SET_HEADER_VISIBILITY:
            return { ...state, headerVisible: action.payload };
        case SET_MAIN_MENU_VISIBILITY:
            return { ...state, mainMenuVisible: action.payload };
        case SET_FOOTER_VISIBILITY:
            return { ...state, footerVisible: action.payload };
        case REFRESH_STATUS_BAR:
            return { ...state, statusBarVersion: state.statusBarVersion + 1 };
        default:
            return state;
    }
}